/* eslint max-len: 0 */
import initMoment from '@eb/moment';

initMoment()
export default initMoment;
